import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Keeps the Law 25 cookie banner hidden on /admin, /prototype/mobile, and app-scoped
 * support / marketing / legal pages (SPA navigations).
 * Initial load is handled in public/pi-consent/pi-consent.js.
 */
export default function PiConsentRouteShell() {
    const { pathname } = useLocation();

    useEffect(() => {
        if (typeof window === "undefined") return;
        const PI = window.PIConsent;
        if (PI && typeof PI.syncPath === "function") {
            PI.syncPath(pathname);
        }
    }, [pathname]);

    return null;
}
